import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ISubscription } from "src/pages/Management/Subscriptions/Subscriptions.types";
import { StyledTd, StyledTr } from "src/styled";

interface Props {
  row: ISubscription;
  children?: React.ReactNode;
}

const SubsRow = ({ row, children }: Props) => {
  const navigate = useNavigate();

  const handleEditSubscription = useCallback(
    (yachtid: string, clientid: string) => {
      navigate(
        `/management/subscriptions/edit-subscription/${yachtid}/${clientid}`,
      );
    },
    [navigate, row.yachtid],
  );

  return (
    <StyledTr
      hover
      onClick={() =>
        handleEditSubscription(
          row.yachtid ? row.yachtid : "",
          row.client ? row.client : "",
        )
      }>
      {children}
      <StyledTd center>{row.lbname}</StyledTd>
      <StyledTd center>{row.type}</StyledTd>
      <StyledTd center>{row.start}</StyledTd>
      <StyledTd center>{row.end}</StyledTd>
      <StyledTd center>{row.active}</StyledTd>
    </StyledTr>
  );
};

export default SubsRow;
